import { pgTable, serial, text, integer, boolean, timestamp } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const submissionChecklistTable = pgTable("submission_checklist", {
  id: serial("id").primaryKey(),
  tenderId: integer("tender_id").notNull(),
  label: text("label").notNull(),
  labelEn: text("label_en"),
  done: boolean("done").notNull().default(false),
  category: text("category").default("general"),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const insertSubmissionChecklistSchema = createInsertSchema(submissionChecklistTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertSubmissionChecklist = z.infer<typeof insertSubmissionChecklistSchema>;
export type SubmissionChecklist = typeof submissionChecklistTable.$inferSelect;
